import { Environment } from './environment.interface';

/**
 * Base Environment Configuration
 *
 * Contains shared configuration values across all environments.
 * This helps avoid duplication and ensures consistency.
 *
 * MVP Version: Minimal configuration
 */

export const baseEnvironment: Partial<Environment> = {
  // Add shared configuration here when needed
  // For MVP, most config will be environment-specific
};
